import { Box, BoxProps } from '@mui/material';
import React from 'react';

interface EllipseProps extends BoxProps {
  width: number | string;
  height: number | string;
  color: string;
  blur: number;
}

const Ellipse: React.FC<EllipseProps> = ({ width, height, color, blur, sx, ...props }) => {
  return (
    <Box
      {...props}
      sx={{
        width,
        height,
        backgroundColor: color,
        borderRadius: '50%',
        filter: `blur(${blur}px)`,
        zIndex: -1,
        ...sx,
      }}
    />
  );
};

export default Ellipse;
